module.exports = __webpack_public_path__ + "img/walk-time.dc3f3c4a.svg";